import type { FC } from 'react';
import { QButton, QText } from '../../QAtoms';
import { useLibraryTranslation } from '../../i18n';

export const FileInputBody: FC<{
  handleBrowse: () => void;
  description?: string;
}> = ({ handleBrowse, description }) => {
  const { t } = useLibraryTranslation();
  return (
    <>
      <QText fontSize="sm" fontWeight="semibold">
        {t('fileInput.dragAndDrop')}
      </QText>
      <QButton variant="outline" onClick={handleBrowse}>
        {t('fileInput.browse')}
      </QButton>
      {description && (
        <QText fontSize="sm" color="gray.500">
          {description}
        </QText>
      )}
    </>
  );
};
